<template>
  <div>
    <div class="contents xpointlist">
      <b-form @submit="onSubmit">
        <div class="filter-box-2">
          <div>
            <select
              class="form-select-lg"
              name="searchtype"
              v-model="searchData.searchtype"
            >
              <option value="P.nickname">
                {{ $t("filter.common.nickname") }}
              </option>
              <option value="TD.title">{{ $t("filter.common.title") }}</option>
            </select>
          </div>
          <div class="input-group">
            <input
              type="text"
              class="form-control"
              name="searchname"
              v-model="searchData.searchname"
            />
            <button
              class="btn btn-primary btn-lg icon-search"
              type="submit"
              value=""
            ></button>
          </div>
        </div>
      </b-form>
      <table class="table board toggle-xxl">
        <thead>
          <tr>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.common.number") }}
            </th>
            <th class="col-auto d-xxl-table-cell">
              {{ $t("title.common.nickname") }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.admin.payment_no") }}
            </th>
            <th class="col-auto d-none d-sm-table-cell">
              {{ $t("title.common.entry_fee") }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.common.title") }}
            </th>
            <th class="col-auto d-none d-xxl-table-cell">
              {{ $t("title.admin.payment_date") }}
            </th>
            <th class="col-auto d-xxl-table-cell">
              {{ $t("title.admin.used_date") }}
            </th>
            <th class="th-arrow"></th>
          </tr>
        </thead>
        <tbody v-if="totalCnt > 0">
          <template v-for="(item, index) in items">
            <tr :key="index">
              <td class="col-auto d-none d-xxl-table-cell w-1">
                {{ item.no }}
              </td>
              <td class="col-auto d-xxl-table-cell">
                {{ item.nickname }}
              </td>
              <td class="col-auto d-none d-sm-table-cell">
                {{ item.tor_key }}
              </td>
              <td class="col-auto d-none d-sm-table-cell">
                {{
                  item.tor_amount | stripe_unit_amount(item.product_currency)
                }}
                <br>
                <template v-if="item.tor_memo && JSON.parse(item.tor_memo).coupon_code">
                  {{
                    item.tor_actual_amount
                      | stripe_unit_amount(item.product_currency)
                  }}
                </template>

              </td>
              <td class="col-auto d-none d-xxl-table-cell">
                {{ item.title }}
              </td>
              <td class="col-auto d-none d-xxl-table-cell">
                {{ item.timezone_approve_regdate | dateformat }}
                <br/>
                      {{ item.tor_memo ? JSON.parse(item.tor_memo).coupon_code : ''}}
              </td>
              <td class="col-auto d-xxl-table-cell text-point-sp">
                <template v-if="item.tod_status == '1'">
                  {{ item.timezone_used_regdate | dateformat }}
                </template>
                <template v-else-if="item.tod_status == '2'">
                  {{ item.timezone_refund_regdate | dateformat }}
                  <br />(refund)
                </template>
                <template v-else>
                  <button
                    type="button"
                    class="btn btn-secondary btn-xs mx-auto"
                    @click="refund(item.tod_pk)"
                  >
                    {{ $t("button.admin.refund") }}
                  </button>
                </template>
              </td>

              <td class="td-arrow" @click="toggle_tr(index)">
                <img
                  src="/img/arrow_none_collapsed.png"
                  :class="{ 'btn-toggle-arrow': view_hide === index }"
                />
              </td>
            </tr>
            <tr
              class="d-xxl-none"
              :class="{ show: view_hide === index }"
              :key="index + 'r'"
              v-if="view_hide === index"
            >
              <td colspan="9">
                <div class="toggle-content">
                  <div class="row">
                    <div class="col-4">{{ $t("title.common.number") }}</div>
                    <div class="col-8">{{ item.no }}</div>
                  </div>
                  <div class="row d-sm-none">
                    <div class="col-4">{{ $t("title.admin.payment_no") }}</div>
                    <div class="col-8">
                      {{ item.tor_key }}
                    </div>
                  </div>

                  <div class="row d-sm-none">
                    <div class="col-4">{{ $t("title.admin.entry_fee") }}</div>
                    <div class="col-8">
                      {{ 5.0 | toFixed | price_unit }}
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.common.title") }}
                    </div>
                    <div class="col-8">{{ item.title }}</div>
                  </div>
                  <div class="row">
                    <div class="col-4">
                      {{ $t("title.admin.payment_date") }}
                    </div>
                    <div class="col-8">
                      {{ item.timezone_regdate | dateformat }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </template>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="9" class="text-center">
              {{ $t("text.common.no_data") }}
            </td>
          </tr>
        </tbody>
      </table>
      <b-pagination-nav
        :link-gen="linkGen"
        :number-of-pages="pageTotal"
        v-model="searchData.pageno"
        use-router
        :aria-label="$t('text.common.pagination')"
        v-if="pageTotal > 1"
        first-class="prev"
        prev-class="prev"
        next-class="next"
        last-class="next"
        hide-ellipsis
        limit="10"
      >
        <template #first-text
          ><i class="material-icons">keyboard_double_arrow_left</i></template
        >
        <template #prev-text
          ><i class="material-icons">navigate_before</i></template
        >
        <template #next-text
          ><i class="material-icons">navigate_next</i></template
        >
        <template #last-text
          ><i class="material-icons">keyboard_double_arrow_right</i></template
        >
        <template #page="{ page, active }">
          <div v-if="active">{{ page }}</div>
          <div v-else>{{ page }}</div>
        </template>
      </b-pagination-nav>
    </div>
  </div>
</template>

<script>
import "@/filter/common";
import ax from "@/api/manager";

export default {
  name: "PaymentList",
  data() {
    return {
      searchData: {
        searchtype:
          this.$route.query.searchtype ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchtype) ||
          "P.nickname",
        searchname:
          this.$route.query.searchname ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].searchname) ||
          "",
        pageno:
          this.$route.query.pageno ||
          (this.$store.state.searchData[this.$route.name] &&
            this.$store.state.searchData[this.$route.name].pageno) ||
          1,
      },
      pageTotal: 1,
      totalCnt: 0,
      dataYn: true,
      rows: 10,
      items: [],
      view_hide: null,
    };
  },
  watch: {
    "searchData.searchtype": function () {
      this.searchData.pageno = 1;
      this.getList();
    },
    "searchData.searchname": function () {
      this.searchData.pageno = 1;
      this.getList();
    },
    "searchData.pageno": function () {
      this.getList();
    },
  },

  created() {
    this.getList();
  },
  methods: {
    refund(tod_pk) {
      ax.post_paymentrefund({ tod_pk: tod_pk }, (flag, data) => {
        alert(data.message);
        if (flag) this.getList();
      });
    },
    onSubmit(event) {
      event.preventDefault();
      this.searchData.pageno = 1;
    },
    getList() {
      this.$store.commit("setSearchData", {
        [this.$route.name]: this.searchData,
      });
      ax.get_paymentlist(this.searchData, (flag, data) => {
        this.totalCnt = data.listcnt;
        this.pageTotal = Math.ceil(data.listcnt / this.rows);
        this.items = data.list;
        if (!flag) alert(data.message);
      });
    },

    linkGen(pageNum) {
      return `?page=${pageNum}`;
    },
    toggle_tr(index) {
      if (this.view_hide === index) this.view_hide = null;
      else this.view_hide = index;
    },
  },
};
</script>
